export default __webpack_public_path__ + "static/media/EDISON_CF-DS-release2-v08.e3b95d78.pdf";